import { CustomFieldType } from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/types";
import { TicketField } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import clsx from "clsx";
import React from "react";
import { InfoIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";

import { getCustomFieldTypeIcons } from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/helper";

interface Props {
  field: TicketField;
  children: React.ReactNode;
  hasError: boolean;
  isFirst: boolean;
  isLast: boolean;
}

export default function FieldWrapper({
  field,
  children,
  hasError,
  isFirst,
  isLast,
}: Props) {

  const customTooltioText = (
    field as TicketField & {
      extraParameters? : {tooltip?: string};
    }
  )?.extraParameters?.tooltip?.trim() || "";

  const rawIcon = getCustomFieldTypeIcons(
    field.fieldToolTip as CustomFieldType,
  );
  const clonedIcon = rawIcon
    ? React.cloneElement(rawIcon as React.ReactElement, {
        size: 20,
        color: "#79808A",
      })
    : null;

  return (
    <div
      className={clsx(
        "w-full flex overflow-hidden border",
        "border-gray-200",

        // rounding
        isFirst && "rounded-t-md",
        isLast && "rounded-b-md",

        // borders between rows
        !isLast && "border-b-0",
      )}
    >
      {/* LEFT LABEL */}
      <div className="flex items-center py-3 gap-1.5 px-4 min-w-[220px] w-[220px]  border-r border-gray-200">
        <div className="flex items-center gap-1.5 truncate h-fit ">
          {clonedIcon}
          <span className="font-medium text-xs text-secondary truncate">
            {field.fieldName}
            {field.isRequired && (
              <span className={clsx(hasError ? "text-danger" : "text-secondary")}>
                *
              </span>
            )}
          </span>
          {customTooltioText ? (
            <CustomTooltip text = {customTooltioText} position="bottom">
              <span className="inline-flex items-center">
                <InfoIcon size="14" color="#BDC0C3" />
              </span>

            </CustomTooltip>
          ) : null}
        </div>
      </div>

      {/* RIGHT INPUT */}
      <div className="flex-1 ">{children}</div>
    </div>
  );
}

